import React from "react";
import ReactDOM from "react-dom"
import Home from "./Home.jsx";
import '@tencent/universe-ui/build/lib/style.js';
import 'tdesign-react/es/style/index.css'; // 少量公共样式
import "./style/var.scss";
import "./index.css";
import { MathJaxContext } from "better-react-mathjax";

import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';

// 全局 MathJax 配置
const mathJaxConfig = {
  loader: { 
    load: [
      "[tex]/html",
      "[tex]/mhchem",     // 化学公式支持 \ce{}
      "[tex]/extpfeil",   // 长等号/箭头支持 \xlongequal{}, \xrightarrow{}
      "[tex]/ams",        // AMS 数学扩展，支持 \stackrel{} 等
      "[tex]/cases"       // cases 环境支持
    ] 
  },
  tex: {
    packages: { "[+]": ["html", "mhchem", "extpfeil", "ams", "cases"] },
    inlineMath: [
      ["$", "$"],
      ["\\(", "\\)"]
    ],
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"]
    ]
  },
  startup: {
    typeset: false // 禁用自动 typeset，让 React 组件控制
  }
};

export default function App() {
  return (
    <MathJaxContext version={3} config={mathJaxConfig}>
      <Router>
        {/* <Route path="/" component={Home} /> */}
        <Route path="*" component={Home} />
      </Router>
    </MathJaxContext>
  )
}

const root = document.getElementById("root")
ReactDOM.render(<App />, root)

